<pathPantalla></pathPantalla>

<div [hidden]="consulta">
 <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>
                 <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            dataField="departamento"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column
                            dataField="conteopregunta" format="fixedPoint"
                            caption="Preguntas enviadas">
                        </dxi-column>
                        <dxi-column
                            dataField="cantidadrespuesta" format="fixedPoint"
                            caption="Preguntas respondidas">
                        </dxi-column>
                        <dxi-column
                            dataField="cantidadfaltante" format="fixedPoint"
                            caption="Preguntas pendientes">
                        </dxi-column>
                        <dxi-column
                        dataField="avance"
                        alignment="center"
                        caption="% de avance">
                    </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Colaboradores"
                            cellTemplate="cellAccionescolaboradores"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Alumnos"
                            cellTemplate="cellAccionesalumnos"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Padres de familia"
                            cellTemplate="cellAccionespadres"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>

                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAccionescolaboradores'">
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(1, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true" *ngIf="cell.data.vercolaborador"></i>
                            </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionesalumnos'">
                        <div>
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(3, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true" *ngIf="cell.data.veralumnokp || cell.data.veralumno"></i>
                            </a>
                        </div>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionespadres'">
                        <div>
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(2, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true" *ngIf="cell.data.verpadre"></i>
                            </a>
                        </div>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #evaluacionpendientedetalle></div>
